module.exports = __webpack_public_path__ + "static/media/icon_classe.78b4a332.svg";